import { z } from 'zod';
import { APPLICATION_ID_LENGTH, DOCUMENT_ID_LENGTH } from '../constants';

export const updateDeleteDocumentSchema = z.object({
  applicationId: z
    .string()
    .length(APPLICATION_ID_LENGTH, `Application ID must be ${APPLICATION_ID_LENGTH} characters long`),
  documentId: z.string().length(DOCUMENT_ID_LENGTH, `Document ID must be ${DOCUMENT_ID_LENGTH} characters long`),
});
